// Package imports:
import React, { useEffect, useState } from 'react';
// Component imports:
import Alert from '../../../ui-elements/Alert/Alert';
import Loading from '../../../ui-elements/Loading/Loading';
import HeadSection from '../../../ui-elements/HeadSection/HeadSection';
import OverviewReportBody from './OverviewReportBody';
// Service imports:
import { GET_KELDAN_API_URL } from '../../../services/config';
import { ErrorMessages } from '../../../services/errorMessages';
// Type imports:
import { IEventReport, IKeldanApiResponse } from '../../../types/KeldanTypes';
import { IPropertySearchResult, IPropertyViewModel } from '../../../types/PropertyTypes';
import { Fetched } from '../../../types/Types';

interface IReportResponse {
    report: IEventReport<IPropertySearchResult>,
    documentsAllowed: boolean
}

const ViewOverview: React.FC<IPropertyViewModel> = ({
    eventId,
    bondsAllowed
}) => {
    const [report, setReport] = useState<Fetched<IEventReport<IPropertySearchResult>>>(null);
    const [documentsAllowed, setDocumentsAllowed] = useState(false);

    const fetchReport = async () => {
        try {
            const url = `${GET_KELDAN_API_URL()}/Property/GetOverview/${eventId}`;
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                }
            });
            if (response.ok) {
                if (response.redirected) {
                    window.location.href = response.url;
                }
                const responseBody: IKeldanApiResponse<IReportResponse> = await response.json();
                const { result, message } = responseBody;
                if (result) {
                    setReport(result.report);
                    setDocumentsAllowed(result.documentsAllowed);
                } else if (message) {
                    setReport(new Error(message));
                } else {
                    setReport(new Error(ErrorMessages.ErrorInRequest));
                }
            } else {
                setReport(new Error(ErrorMessages.RequestFailed));
            }
        } catch (e) {
            setReport(new Error(ErrorMessages.OtherShort));
        }
    }

    useEffect(() => {
        fetchReport();
    }, []);

    const displayReport = () => {
        if (report instanceof Error) {
            return <Alert type='error' headText={report.message} />;
        }
        if (report === undefined || report === null) {
            return <Loading />;
        }
        return <OverviewReportBody
            report={report}
            bondsAllowed={bondsAllowed}
            documentsAllowed={documentsAllowed}
        />;
    }

    return (
        <div className='main KCL_property-page'>
            <div className='main__inner fluid'>
                <div className='shell'>
                    <HeadSection
                        title='Yfirlitsmynd'
                        showRecentReports
                    />
                    {displayReport()}
                </div>
            </div>
        </div>
    );
}

export default ViewOverview;